import * as React from "react";
const SvgProfileUserActive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g fill="#fff" clipPath="url(#profileUserActive_svg__a)">
      <path d="M9.026 2.02a4.745 4.745 0 0 0-4.741 4.74c0 2.566 2.006 4.642 4.62 4.732.08-.01.16-.01.22 0h.07a4.73 4.73 0 0 0 4.572-4.731A4.745 4.745 0 0 0 9.026 2.02M14.097 14.145c-2.785-1.856-7.326-1.856-10.13 0C2.698 14.994 2 16.142 2 17.37s.699 2.366 1.956 3.204c1.398.938 3.234 1.407 5.07 1.407s3.674-.469 5.07-1.407c1.258-.848 1.957-1.986 1.957-3.224-.01-1.227-.699-2.365-1.956-3.204M19.994 7.348c.16 1.936-1.218 3.633-3.124 3.862h-.05c-.06 0-.12 0-.17.02-.968.05-1.856-.26-2.525-.828a4.57 4.57 0 0 0 1.497-3.793 4.63 4.63 0 0 0-.768-2.176 3.585 3.585 0 0 1 5.14 2.914" />
      <path d="M21.99 16.582c-.08.968-.7 1.807-1.738 2.376-.998.549-2.255.808-3.503.778.719-.649 1.138-1.457 1.218-2.315.1-1.238-.49-2.426-1.667-3.374a8.2 8.2 0 0 0-2.296-1.258c2.206-.638 4.98-.21 6.688 1.168.918.739 1.387 1.667 1.297 2.625" />
    </g>
    <defs>
      <clipPath id="profileUserActive_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgProfileUserActive;
